<template>
  <div class="pins sousuye">
    <van-overlay :show="queryTimes > 0">
      <div class="wrapper" @click.stop>
        <van-loading size="24px" vertical>加载中...</van-loading>
      </div>
    </van-overlay>
    <van-cell class="sousuokuang" title="" label="搜索课程" @click="chans">
      <!-- 使用 right-icon 插槽来自定义右侧图标 -->
      <template #right-icon>
        <van-icon name="search" class="search-icon"/>
      </template>
    </van-cell>
    <div class="course-filter">
      <van-field
        readonly
        clickable
        is-link
        v-model="subjectFilter.text"
        placeholder="学科"
        @click="showSubjectFilter = true"
        style="width: 33%; float: left"
      />
      <van-field
        readonly
        clickable
        is-link
        v-model="gradeFilter.text"
        placeholder="年级"
        @click="showGradeFilter = true"
        style="width: 33%; float: left"
      />
      <van-field
        readonly
        clickable
        is-link
        v-model="yearFilter.text"
        placeholder="年份"
        @click="showYearFilter = true"
        style="width: 33%; float: left"
      />
      <van-popup v-model:show="showSubjectFilter" round position="bottom">
        <van-picker
          show-toolbar
          toolbar-position="bottom"
          :columns="subjectList"
          @cancel="showSubjectFilter = false"
          @confirm="onConfirmSubjectFilter"
          cancel-button-text="取消"
          confirm-button-text="确定"
        />
      </van-popup>
      <van-popup v-model:show="showGradeFilter" round position="bottom">
        <van-picker
          show-toolbar
          toolbar-position="bottom"
          :columns="gradeList"
          @cancel="showGradeFilter = false"
          @confirm="onConfirmGradeFilter"
          cancel-button-text="取消"
          confirm-button-text="确定"
        />
      </van-popup>
      <van-popup v-model:show="showYearFilter" round position="bottom">
        <van-picker
          show-toolbar
          toolbar-position="bottom"
          :columns="yearList"
          @cancel="showYearFilter = false"
          @confirm="onConfirmYearFilter"
          cancel-button-text="取消"
          confirm-button-text="确定"
        />
      </van-popup>
    </div>
    <div class="magtop">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="木有更多了~"
          @load="onLoad"
          class="bai di mtop"
        >
          <van-row
            gutter="10"
            class="mag"
            v-for="(list, index) in courlist"
            :key="index"
            @click="dianjis(list.lessonId,list.courseTypeid)"
          >
            <van-col span="8" class="posjhu">
              <img
                :src="list.serverHttp+list.courseImg"
                width="100%"
                class="kecimg"
                v-if="list.courseImg&&list.courseImg!==''"
              />
              <img
                src="../../assets/img/zbmr.png"
                width="100%"
                class="kecimg"
                v-else
              />
              <span class="fpoad-span">{{ list.courseHour }}课时</span>
              <!-- <span class="fpoad-span" v-if="list.courseTypeid==2">{{ list.courseHour }}课时</span>
              <span class="fpoad-span" v-if="list.courseTypeid==1">
                <span style="font-size: 10px !important;" v-if="list.liveStatus==2">未开始</span>
                <span style="font-size: 10px !important;" v-if="list.liveStatus==3">已结束</span>
                <span style="font-size: 10px !important;" v-if="list.liveStatus==1">直播中</span>
                <span style="font-size: 10px !important;" v-if="list.liveStatus==4">查看回放</span>
              </span> -->
            </van-col>
            <van-col span="16">
              <van-col span="24" class=" touhei heise " style="max-width: 100%;"
                       :class="list.courseTypeid==1?'':'gaodu'">
                {{ list.courseName }}
              </van-col>
              <van-col span="24" style="margin-top: 10px;" v-if="list.courseTypeid==1">
                <van-col span="24" class="spanhong">
                  <span>{{ yue(list.beginTime) }}</span>
                  <span>{{ getWeekDay(list.beginTime) }}</span>
                  <span>{{ slices(list.beginTime, list.endTime) }}</span>
                </van-col>
              </van-col>
              <van-col span="24">
                <van-col span="24" class="spanhong">
                  <span class="lanm biao-span" v-if="list.classifyName">{{
                      list.classifyName
                    }}</span>
                  <span class="hongmu biao-span" v-if="list.courseLimit == 10"
                  >公开课</span
                  >
                  <span class="huanggu biao-span" v-if="list.courseLimit !== 10"
                  >授权观看</span
                  >
                  <!-- <span class="magtop chefudui huisezi"
                    >{{ list.courseViewnum }}<img src="../../assets/img/kan.png" width="15px" style="vertical-align: middle;margin-left: 3px;"/></span
                  > -->
                </van-col>
              </van-col>
            </van-col>
          </van-row>
        </van-list>
      </van-pull-refresh>
    </div>
    <van-empty
      class="custom-image"
      :image="img"
      v-if="courlist && courlist.length === 0"
      description="暂时没有课程"
    />
    <dibu class="dibu"></dibu>
  </div>
</template>

<style>
.van-field__control {
  text-align: center;
}
</style>

<script>
import {courselist, getSubjectList, getGradeList} from "@/api/home";
import {ERR_OK} from "@/api/index";
import dibu from "@/components/index/di";

export default {
  data() {
    return {
      queryTimes: 0,
      loading: false,
      index: "-999",
      famousTeacherId: null,
      finished: false,
      refreshing: false,
      isLoading: false,
      img: require("../../assets/img/kong.png"),
      curPage: 0,
      list: [],
      courlist: [],
      imglist: [
        {advImg: require("../../assets/img/lunb.png"), id: 0},
        {advImg: require("../../assets/img/lunb.png"), id: 1},
      ],
      subjectFilter: {
        id: null,
        text: null
      },
      showSubjectFilter: false,
      gradeFilter: {
        id: null,
        text: null
      },
      showGradeFilter: false,
      yearFilter: {
        id: null,
        text: null
      },
      showYearFilter: false,
      subjectList: [],
      gradeList: [],
      yearList: []
    };
  },
  watch: {
    index() {
      this.ishju = true;
      this.onRefresh();
      if (this.index == 0 || this.index == -1) {
        this.courseclassi(this.index);
      }
    },
  },
  components: {dibu},
  methods: {
    onRefresh() {
      this.finished = false;
      this.courlist = [];
      this.loading = true;
      this.curPage = 1;
      this.courselist();
    },
    onLoad() {
      if (this.ishju) {
        this.curPage++;
        this.courselist();
      }
    },
    courselist() {
      let that = this;
      that.queryTimes++;
      that.loading = true;
      that.isLoading = true;
      let params = {
        curPage: this.curPage,
        pageSize: 10,
        courseState: 1,
        // courseTypeid: 2,
        groupId: 1,
        // 点击常态活动显示全部
        courseClassify: (this.index == 0 || this.index == -1) ? "" : this.index,
        isHaveHour: 1,
        famousTeacherId: this.famousTeacherId,
        subjectId: this.subjectFilter.id,
        gradeId: this.gradeFilter.gradeId,
        year: this.yearFilter.id
      };
      courselist(params)
        .then((res) => {
          for (var i = 0; i < res.data.data.dataList.length; i++) {
            that.courlist.push(res.data.data.dataList[i]);
          }
          if (that.courlist.length >= res.data.data.totalCount) {
            that.finished = true;
          }
          if (res.data.data.totalCount == 0) {
            that.ishju = false;
            that.finished = false;
          }
          that.queryTimes--;
          that.loading = false;
          that.isLoading = false;
        })
        .catch(() => {
          that.queryTimes--;
          that.loading = false;
          that.isLoading = false;
        });
    },
    dianjis(s, d) {
      if (d == 2) {
        this.$router.push({
          path: "/indexvideo",
          query: {
            id: s,
          },
        });
      } else {
        this.$router.push({
          path: "/video",
          query: {
            id: s,
            t: Date.now()
          },
        });
      }
    },
    chans() {
      this.$router.push({
        path: "/search",
        query: {
          famousTeacherId: this.famousTeacherId,
        },
      });
    },
    yue(s) {
      if (s) {
        return s.slice(5, 11);
      }
    },
    yuetu(s) {
      s = s / 10000;
      s = s.toFixed(2);
      return s + "万";
    },
    getWeekDay(dateString) {
      if (!dateString) {
        return false
      }
      dateString = dateString.slice(0, 10);
      var dateArray = dateString.split("-");
      var date = new Date(
        dateArray[0],
        parseInt(dateArray[1] - 1),
        dateArray[2]
      );
      return "周" + "日一二三四五六".charAt(date.getDay());
    },
    slices(s, d) {
      if (s && d) {
        return s.slice(10, 16) + " -" + d.slice(10, 16);
      }
    },
    tiaozhuan(id, classifyName) {
      if (classifyName === "名师工作室") {
        this.$router.push({
          path: "/studio",
          query: {
            id: id,
          },
        });
      } else {
        this.index = id;
      }
    },
    //获取学科列表
    callGetSubjectList() {
      //参数
      let params = {};
      let _this = this;
      //接口
      getSubjectList(params)
        .then((res) => {
          let {data} = res;
          if (data.code === ERR_OK) {
            //获取学科列表
            _this.subjectList = data.data;
            _this.subjectList.forEach(subject => subject.text = subject.name);
            _this.subjectList.unshift({
              id: "",
              text: "请选择学科",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //获取年级列表
    callGetGradeList() {
      //参数
      let params = {
        schoolId: 0,
      };
      let _this = this;
      //接口
      getGradeList(params)
        .then((res) => {
          let {data} = res;
          if (data.code === ERR_OK) {
            //获取年级列表
            _this.gradeList = data.data;
            _this.gradeList.forEach(grade => grade.text = grade.name);
            _this.gradeList.unshift({
              gradeId: "",
              text: "请选择年级",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 初始化年份列表
    initYearList() {
      const currentYear = new Date().getFullYear();
      for (let index = currentYear; index >= 2020; index--) {
        this.yearList.push({
          id: index,
          text: index
        });
      }
      this.yearList.unshift({
        id: "",
        text: "请选择年份",
      });
    },
    onConfirmSubjectFilter(item) {
      if (item.id) {
        this.subjectFilter = item;
      } else {
        this.subjectFilter = {}
      }
      this.showSubjectFilter = false;
      this.onRefresh();
    },
    onConfirmGradeFilter(item) {
      if (item.gradeId) {
        this.gradeFilter = item;
      } else {
        this.gradeFilter = {}
      }
      this.showGradeFilter = false;
      this.onRefresh();
    },
    onConfirmYearFilter(item) {
      if (item.id) {
        this.yearFilter = item;
      } else {
        this.yearFilter = {}
      }
      this.showYearFilter = false;
      this.onRefresh();
    }
  },
  mounted() {
    this.callGetSubjectList();
    this.callGetGradeList();
    this.initYearList();
    this.$nextTick(() => {
      if (this.$route.query.id == 0 || this.$route.query.id) {
        this.index = this.$route.query.id
          ? this.$route.query.id.toString()
          : "0";
      }
      this.famousTeacherId = this.$route.query.famousTeacherId;
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/index/course.vue